var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNylas = function SvgNylas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nylas_svg2__logosandtypes_com",
    viewBox: "0 0 150 150",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nylas_svg2__cls-2{fill:#4169e1}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.39 22.48c-17.2-17.89-48.38-17.9-65.57 0L14.4 69.73c-3.74 3.51-.91 10.31 4.23 10.12 1.58 0 3.09-.63 4.21-1.75l47.41-47.25c12.9-12.99 35.69-12.83 48.4.35 13.21 12.68 13.37 35.39.32 48.24l-47.41 47.25a5.9 5.9 0 0 0-1.75 4.19c-.18 5.11 6.65 7.96 10.16 4.21l47.41-47.26c17.93-17.22 17.93-48.13 0-65.35Z",
    className: "nylas_svg2__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.74 55.14c.4-15.97-15.7-29.06-31.25-25.55a26.2 26.2 0 0 0-13.39 7.14L13.11 99.5c-5.13 5.6 2.84 13.48 8.42 8.37l62.3-62.02c.47-.57.99-1.05 1.57-1.55 12.97-10.7 30.59 5.84 20.56 19.4l-.04.06c-.77 1.02-1.68 1.93-2.71 2.7l-61.52 61.52c-3.76 3.49-.92 10.31 4.21 10.12 1.58 0 3.09-.62 4.21-1.74l62.99-62.78c4.88-4.81 7.7-11.6 7.65-18.45Z",
    className: "nylas_svg2__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.69 68.07c-3.49-1.52-6.09-4.46-7.48-7.96l-69.59 69.35a8.06 8.06 0 0 0-2.4 4.83c-.23 1.62.32 3.32 1.46 4.5 2.63 2.57 7.05 1.52 9.39-.94l69.56-69.36-.93-.43Z",
    className: "nylas_svg2__cls-2"
  })));
};
export default SvgNylas;